import HttpProvider from 'providers/HttpProvider';
import Home from 'screens/Home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChatbotProvider } from 'providers/ChatbotProvider';
import { ErrorBoundary } from 'react-error-boundary';
import { Button } from 'primereact/button';
import { datadogRum } from '@datadog/browser-rum';
import { LinkPreviewProvider } from './components/LinkPreviewContext';

const FallbackComponent = ({ error, resetErrorBoundary }) => (
    <div role="alert">
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
        <Button onClick={resetErrorBoundary} label="Try again" />
    </div>
);

const App = () => {
    var pathname = window.location.pathname.slice(0, window.location.pathname.length - 1);

    let Originurl = window.location.origin.toString();
    if (!Originurl.includes('localhost')) {
        datadogRum.init({
            applicationId: '721f7aee-4407-4bd1-b5fe-7b9d992f0658',
            clientToken: 'pub1b7bd2b3f75e82f8e811ea6456f1b7da',
            site: 'datadoghq.com',
            service: process.env.REACT_APP_DATADOG_NAME,
            env: process.env.REACT_APP_ENV,
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sampleRate: 100,
            sessionReplaySampleRate: 100,
            trackInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'allow'
        });
    }

    return (
        <ErrorBoundary FallbackComponent={FallbackComponent}>
            <HttpProvider>
                <LinkPreviewProvider>
                    <ChatbotProvider>
                        <div className="fade-in">
                            <Home />
                        </div>
                    </ChatbotProvider>
                </LinkPreviewProvider>
            </HttpProvider>
        </ErrorBoundary>
    );
};

export default App;
